import React, { Fragment } from 'react'
import _ from 'lodash'
import { FormInputCheckbox } from 'camino-react'

import { sumTwoDecimalPlaces } from 'Utilities/Math'

const TicketReviewLine = ({ ticket, updateReportState, ticketsToApprove }) => (ticket.reviewed ? (
  <p style={{ margin: '0' }}>
    Reviewed
  </p>
) : (
  <div style={{ display: 'flex', flexDirection: 'columns' }}>
    <FormInputCheckbox
      value={_.includes(_.map(ticketsToApprove, 'id'), ticket.id)}
      onValue={() => {
        if (_.includes(_.map(ticketsToApprove, 'id'), ticket.id)) {
          const newTicketsToApprove = _.filter(ticketsToApprove, t => t.id !== ticket.id)
          updateReportState({ ticketsToApprove: newTicketsToApprove })
        } else {
          updateReportState({ ticketsToApprove: [...ticketsToApprove, ticket] })
        }
      }}
    />
    Mark for approval
  </div>
))

const buttonStyles = {
  background: 'transparent',
  padding: 0,
  margin: 0,
  textTransform: 'uppercase',
  color: '#00BAEA',
  fontWeight: 700,
  fontSize: '14px',
  border: 0,
  outline: 0
}

const setColumns = ({ updateReportState, ticketsToApprove, showReviewed }) => {
  const defaultColumns = [
    {
      text: 'Client name',
      id: 'clientName',
      accessor: 'clientName'
    },
    {
      text: 'Tickets',
      id: 'ticket',
      accessor: t => `${t.ticket.alert ? '(Alert) ' : ''} #${t.ticket.id} - ${t.ticket.title}`,
      aggregate: tickets => tickets.length
    },
    {
      text: 'Resolved At',
      id: 'resolvedAt',
      accessor: timesheet => ({ resolvedAt: timesheet.ticket.resolved_at, text: '' }),
      aggregate: vals => vals[0].resolvedAt
    },
    {
      text: 'Invoicing',
      id: 'link',
      accessor: timesheet => ({ timesheet, ticket: timesheet.ticket, text: timesheet.description }),
      aggregate: (vals) => {
        const timesheetWithTicket = _.find(vals, 'ticket')
        if (_.isNil(timesheetWithTicket)) { return undefined }
        const timesheets = _(vals).map(val => _.omit(val.timesheet, 'ticket')).compact().value()
        const currentTicket = { ...timesheetWithTicket.ticket, timesheets }

        return (
          <Fragment>
            <TicketReviewLine {...{ ticket: currentTicket, updateReportState, ticketsToApprove }} />

            <button
              type="button"
              style={buttonStyles}
              onClick={(event) => {
                updateReportState({ currentTicket })
              }}
            >
              Open Invoicing Section
            </button>
          </Fragment>
        )
      }
    },
    {
      text: 'Rate',
      id: 'chargeableRate',
      accessor: t => parseInt(_.get(t, 'ticket.chargeable_rate', 0), 10),
      aggregate: (values, rows) => `${_.round(_(values).compact().map(value => parseInt(value, 10)).mean(), 2)} (avg)`
    },
    {
      text: 'Service Group',
      accessor: 'serviceGroupName',
      Aggregated: _row => undefined
    },
    {
      text: 'Work Type',
      accessor: 'workTypeName',
      Aggregated: _row => undefined
    },
    {
      text: 'Work Role',
      accessor: 'workRoleName',
      Aggregated: _row => undefined
    },
    {
      id: 'hoursLogged',
      text: 'Hours logged',
      accessor: t => _.round(t.hours, 2),
      aggregate: vals => sumTwoDecimalPlaces(vals),
      Aggregated: row => (
        <span key={row.value}>
          {`${_.round(row.value, 2)} (total)`}
        </span>
      )
    },
    {
      text: 'Chargeable hours',
      id: 'chargeableHours',
      accessor: t => t.chargeable && t.hours || 0,
      aggregate: vals => _.sum(_.map(vals, val => (val === null ? 0 : parseFloat(val)))),
      Aggregated: row => (
        <span key={row.value}>
          {`${_.round(row.value, 2)} (agg)`}
        </span>
      )
    }
  ]

  let tableColumns = defaultColumns
  tableColumns = (!showReviewed ? tableColumns : [...tableColumns, {
    text: 'Reviewed?',
    accessor: t => `${t.ticket.reviewed ? 'True' : 'False'}`,
    id: 'reviewed',
    aggregate: vals => _.find(vals, val => val === 'False') || 'True'
  }])

  return (tableColumns)
}

export default setColumns
